export const environment = {
  production: false,
  apiBaseUrl: 'https://stage-api.humazemd.com',
  stripePublishKey: 'pk_test_muAcWXAPWZf4HQJ6rgwEl2C5'
};
